import { useState } from 'react';
import { AritoFormV2, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { FormSchema, initialFormValues, type FormValues } from '../schema';
import type { KhuVuc, KhuVucInput } from '@/types/schemas/khu-vuc.type';
import { useSearchFieldStates } from '../hooks';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: KhuVucInput) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: KhuVuc | null;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: FormDialogProps) => {
  const [error, setError] = useState<string | null>(null);

  const { parent, setParent, nh_rg1_group, setGroup1, nh_rg2_group, setGroup2, nh_rg3_group, setGroup3 } =
    useSearchFieldStates(initialData ?? undefined);

  const handleSubmit = async (data: FormValues) => {
    const updatedData: KhuVucInput = {
      ...data,
      parent_rg: parent?.uuid || null,
      nh_rg1: nh_rg1_group?.uuid || null,
      nh_rg2: nh_rg2_group?.uuid || null,
      nh_rg3: nh_rg3_group?.uuid || null
    };
    onSubmit(updatedData);
  };

  const title = formMode === 'add' ? 'Thêm khu vực' : formMode === 'edit' ? 'Sửa khu vực' : 'Xem khu vực';

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={title}
      maxWidth='md'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
    >
      <AritoFormV2
        mode={formMode}
        hasAritoActionBar={false}
        onSubmit={handleSubmit}
        schema={FormSchema}
        initialData={(initialData as Partial<FormValues> | null | undefined) || initialFormValues}
        className='w-full md:min-w-[500px] lg:min-w-[600px]'
        headerFields={
          <BasicInfo
            formMode={formMode}
            parent={parent}
            nh_rg1_group={nh_rg1_group}
            nh_rg2_group={nh_rg2_group}
            nh_rg3_group={nh_rg3_group}
            setGroup1={setGroup1}
            setGroup2={setGroup2}
            setGroup3={setGroup3}
            setParent={setParent}
          />
        }
        bottomBar={
          <BottomActionBarV2
            mode={formMode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onClose={onClose}
          />
        }
      />
      {error && <div className='mx-4 mb-4 rounded bg-red-100 p-2 text-red-700'>{error}</div>}
    </DialogV2>
  );
};

export default FormDialog;
